import Vue from "vue";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// Um aviso por requisição que falhou. O interceptor do axios (main.js) chama notifyRequestError, que só
// mostra o aviso depois que a tela trata o erro: se a tela mostrou a mensagem dela, o aviso genérico
// é dispensado; se ela só repetiu o texto técnico do axios ("Error: Request failed..."), fica o aviso
// em português. Avisos com o mesmo texto já na tela não aparecem de novo.
let pending = [];

const isTechnical = content => content instanceof Error || /^\w*Error: /.test(String(content));

// 401/403/404 têm texto fixo; nos demais erros vale a mensagem do servidor, quando ela vem. Em 422, a lista
// de erros de validação (o servidor manda em português) diz o que corrigir.
export function requestErrorMessage(error) {
  const res = error && error.response;
  if (!res) return "Sem resposta do servidor. Verifique a conexão e tente de novo.";
  if (res.status === 422 && /\/sign_in$/.test((error.config && error.config.url) || "")) return "Usuário ou senha inválidos.";
  if (res.status === 401) return "Sessão expirada. Entre de novo no sistema.";
  if (res.status === 403) return "Você não tem permissão para esta ação.";
  if (res.status === 404) return "Registro não encontrado.";
  if (res.data && typeof res.data.error === "string") return res.data.error;
  const errors = res.status === 422 && res.data && res.data.errors;
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors) && errors.length && errors.every(e => typeof e === "string")) return errors.join("; ");
  return `Não foi possível concluir a operação (erro ${res.status}).`;
}

export function notifyRequestError(error) {
  const entry = { message: requestErrorMessage(error) };
  pending.push(entry);
  // a tela trata o erro nas microtasks da mesma rejeição; o aviso genérico espera ela terminar
  setTimeout(() => {
    pending = pending.filter(e => e !== entry);
    if (!entry.handled) Vue.$toast.error(entry.message);
  });
}

const options = {
  timeout: 5000,
  filterBeforeCreate(toast, toasts) {
    if (toast.type === "error" && pending.length) {
      if (isTechnical(toast.content)) return false;
      pending.forEach(e => { e.handled = true; });
    }
    return toasts.some(t => t.content === toast.content) ? false : toast;
  }
};

Vue.use(Toast, options);

export default Toast;
